import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import featureImg1 from "../../assets/images/home/fp1.png";
import featureImg2 from "../../assets/images/home/fp2.png";
import featureImg3 from "../../assets/images/home/fp3.png";
import { FaBuilding } from "react-icons/fa";
import { IoBed } from "react-icons/io5";
import { FaBath } from "react-icons/fa6";


export const FeaturedProperty = () => {
  return (
    <div className="featuredContainer">
      <div className="container">
        <div className="featureTitle">Featured Properties</div>
        <div className="trendContainer">
          <div>Trending Right Now on SnapBid</div>
          <div>
           <a href="/properties"> View All Properties <FaArrowRightLong /></a> 
          </div>
        </div>
        <div className="featureCardGrid">
            <div className="featureCard">
                <div className="featureImg">
                     <img src={featureImg1}/>
                </div>
                <div className="featureCardContent">
                    <div>Serenity Villa</div>
                    <div>A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban neighborhood...</div>

                </div>
                <div className="featureMenu">
                    <div><span className="pe-1"><IoBed /></span>4-Bedroom</div>
                    <div><span className="pe-1"><FaBath /></span>3-Bathroom</div>
                    <div><span className="pe-1"><FaBuilding /></span>Villa</div>

                </div>
                <div className="priceContainer">
                    <div>
                        <div className="textPrice">Price</div>
                        <div className="textRupee"><span>₹55,00,000</span><span><strike>₹65,00,000</strike></span></div>
                    </div>
                    <div >
                        <div>&nbsp;</div>
                        <button className="btnView">View Details</button>
                    </div>

                </div>

            </div>

              <div className="featureCard">
                <div className="featureImg">
                     <img src={featureImg2}/>
                </div>
                <div className="featureCardContent">
                    <div>Serenity Villa</div>
                    <div>A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban neighborhood...</div>

                </div>
                <div className="featureMenu">
                    <div><span className="pe-1"><IoBed /></span>4-Bedroom</div>
                    <div><span className="pe-1"><FaBath /></span>3-Bathroom</div>
                    <div><span className="pe-1"><FaBuilding /></span>Villa</div>

                </div>
                <div className="priceContainer">
                    <div>
                        <div className="textPrice">Price</div>
                        <div className="textRupee"><span>₹55,00,000</span><span><strike>₹65,00,000</strike></span></div>
                    </div>
                    <div >
                        <div>&nbsp;</div>
                        <button className="btnView">View Details</button>
                    </div>

                </div>

            </div>

              <div className="featureCard">
                <div className="featureImg">
                     <img src={featureImg3}/>
                </div>
                <div className="featureCardContent">
                    <div>Serenity Villa</div>
                    <div>A stunning 4-bedroom, 3-bathroom villa in a peaceful suburban neighborhood...</div>

                </div>
                <div className="featureMenu">
                     <div><span className="pe-1"><IoBed /></span>4-Bedroom</div>
                    <div><span className="pe-1"><FaBath /></span>3-Bathroom</div>
                    <div><span className="pe-1"><FaBuilding /></span>Villa</div>

                </div>
                <div className="priceContainer">
                    <div>
                        <div className="textPrice">Price</div>
                        <div className="textRupee"><span>₹55,00,000</span><span><strike>₹65,00,000</strike></span></div>
                    </div>
                    <div >
                        <div>&nbsp;</div>
                        <button className="btnView">View Details</button>
                    </div>

                </div>

            </div>

        </div>
      </div>
    </div>
  );
};
